import React, { useEffect, useState } from "react";
import moment from "moment";

const FnTableItemComponent = ({ data, showAction, onSelectionChange }) => {
  const [rows, setRows] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);

  useEffect(() => {
    const selectedIds = rows.filter(r => r.isChecked).map(r => r.MatchId);
    onSelectionChange?.(selectedIds);
  }, [rows, onSelectionChange]);

  useEffect(() => {
    if (!data?.Result) return;

    const prepared = data.Result.map(match => {
      let teams = [];
      try {
        teams = JSON.parse(match.TeamInfo || "[]");
      } catch (e) {
        console.error("Team parse error", e);
      }

      return { ...match, teams, isChecked: false };
    });

    setRows(prepared);
  }, [data]);

  const handleCheckAll = () => {
    const updated = rows.map(r => ({ ...r, isChecked: !checkedAll }));
    setRows(updated);
    setCheckedAll(!checkedAll);
  };

  const handleCheckRow = index => {
    const updated = rows.map((r, i) =>
      i === index ? { ...r, isChecked: !r.isChecked } : r
    );
    setRows(updated);
    setCheckedAll(updated.every(r => r.isChecked));
  };

  return (
    <div>
      <table className="table table-bordered" width="100%">
        <thead>
          <tr>
            <th>Match ID</th>
            <th>Match Date</th>
            <th>Match Name</th>
            <th>Match Type</th>
            <th>Teams</th>
            <th>Status Code</th>
            <th>Live Status</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((match, index) => (
            <tr key={match.MatchId}>
              <td>{match.MatchId}</td>
              <td>{moment(match.MatchDate).format("DD-MM-YYYY hh:mm A")}</td>
              <td>{match.MatchName}</td>
              <td>{match.MatchType}</td>

              <td>
                {match.teams?.length === 2
                  ? `${match.teams[0].teamSName} vs ${match.teams[1].teamSName}`
                  : "N/A"}
              </td>

              <td>{match.Status}</td>
              <td>{match.InPlay ? "Live" : "Not Live"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FnTableItemComponent;
